const updateHint = (action) => {
    const hint = action?.querySelector('[data-recipient-hint]');

    if (!hint) {
        return;
    }

    const templateSelect = action.querySelector('select[name="emailTemplate"]');

    if (!templateSelect) {
        return;
    }

    if (templateSelect.value === '') {
        hint.textContent = '';

        return;
    }

    const overridesByTemplate = JSON.parse(hint.dataset.templateOverrides || '{}');
    const addresses           = overridesByTemplate[templateSelect.value] ?? [];

    hint.textContent = addresses.length === 0
        ? hint.dataset.textCustomer
        : hint.dataset.textOverride.replace('%s', addresses.join(', '));
};

export const updateRecipientHints = (root) => {
    root.querySelectorAll('[data-recipient-hint]').forEach(hint => updateHint(hint.closest('.automation-action')));
};

export const synchronizeRecipientHint = (event) => {
    updateHint(event.target.closest?.('.automation-action'));
};

export const initializeRecipientHint = (event) => {
    updateRecipientHints(event.detail.action);
};
